export enum ComplianceAction {
  BYPASS = 'BYPASS',
  BLOCK = 'BLOCK',
  CHECK_AND_ASK = 'CHECK_AND_ASK'
}
